import { Outlet, Navigate } from "react-router-dom";
import {useAuth, UserStatus} from "./AuthProvider";
import Footer from "../components/views/public/Footer";
import {Flex} from "@chakra-ui/react";

const RoutesForUnauthenticatedUsers = () => {
  const { userStatus } = useAuth();
  
  return (userStatus === UserStatus.None || userStatus === null) ?
      <>
          <Flex
              as="main"
              mb="50px" // Zwiększ margines od dołu, aby kontener nie był zasłonięty przez footer
              justifyContent="center"
              alignItems="center"
              width="100%"
          >
              <Outlet />
          </Flex>
        <Footer />
      </>
      :
      <Navigate to="/" />;
};

export default RoutesForUnauthenticatedUsers;